/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getStatement} from '../api'

 export const useQueryGetStatement = createReactQueryHook('getStatement', getStatement)
